<template>
  <div class="layout-preview">
    <div class="preview-header">
      <span class="preview-title">预览</span>
    </div>
    <div class="preview-body" v-loading="loading">
      <el-scrollbar class="preview-scroll">
        <div class="preview-content">
          <div v-for="module in data" :key="module.id" class="preview-module">
            <div class="module-title">
              {{ module.name || module.id }}
            </div>
            <div class="module-resources">
              <div v-for="res in (module.resources || []).slice(0, 12)" :key="res.shipId || res.id"
                class="resource-item">
                <el-image v-if="getResourceThumb(res)" :src="getResourceThumb(res)" fit="cover" class="resource-thumb"
                  :preview-src-list="[getResourceThumb(res)]" />
                <div v-else class="resource-thumb resource-thumb-empty">-</div>
                <div class="resource-name" :title="getResourceTitle(res)">
                  {{ getResourceTitle(res) }}
                </div>
              </div>
              <div v-if="!(module.resources || []).length" class="empty-resources">
                暂无资源
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { valueByLanguage } from "@/utils/college";

export default {
  name: "LayoutConfigPreView",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getResourceThumb(res) {
      if (!res) return "";

      const { resourceType } = res;

      // STICKER / TEMPLATE / MATERIAL：使用 thumbnail
      if (["STICKER", "TEMPLATE", "MATERIAL"].includes(resourceType)) {
        if (Array.isArray(res.thumbnail) && res.thumbnail.length) {
          const first = res.thumbnail[0];
          if (first && first.url) return first.url;
          if (first && first.value) return first.value;
        }
        const thumb = valueByLanguage(res.thumbnail, "zh_CN", true) || "";
        if (thumb) return thumb;
      }

      // COLLECTION：使用 bgFileAssetId
      if (resourceType === "COLLECTION" && Array.isArray(res.bgFileAssetId)) {
        const bg = res.bgFileAssetId.find(item => item.locale === "zh_CN") || res.bgFileAssetId[0];
        if (bg) {
          if (bg.url) return bg.url;
          if (bg.value) return bg.value;
        }
      }

      // BANNER：使用 fileAssetId
      if (resourceType === "BANNER" && Array.isArray(res.fileAssetId)) {
        const file = res.fileAssetId.find(item => item.locale === "zh_CN") || res.fileAssetId[0];
        if (file) {
          if (file.url) return file.url;
          if (file.value) return file.value;
        }
      }

      // 兜底：尽量兼容历史字段
      const fallback = valueByLanguage(res.thumbnail, "zh_CN", true) || res.cover || res.image || "";
      return fallback || "";
    },
    getResourceTitle(res) {
      if (!res) return "-";
      return (
        valueByLanguage(res.title, "zh_CN", true) ||
        valueByLanguage(res.name, "zh_CN", true) ||
        res.nameText ||
        res.name ||
        res.id ||
        "-"
      );
    }
  }
};
</script>

<style scoped>
.layout-preview {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.preview-header {
  flex: 0 0 auto;
  padding: 8px 0;
}

.preview-title {
  font-size: 14px;
  font-weight: 600;
}

.preview-body {
  flex: 1;
  min-height: 0;
  border: 1px solid #f2f2f2;
}

.preview-scroll {
  height: 100%;
}

.preview-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.preview-module {
  border-bottom: 1px dashed #ebeef5;
  padding-bottom: 12px;
}

.module-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-resources {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.resource-item {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: hidden;
}

.resource-thumb {
  width: 56px;
  height: 56px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

.resource-thumb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
}

.resource-name {
  flex: 1;
  font-size: 12px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-resources {
  grid-column: 1 / -1;
  color: #909399;
  font-size: 12px;
}
</style>
